import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/SideBar";
import Footer from "../components/Footer";
import "./layout.css";
import PageTitle from "../components/PageTitle";

const Layout = () => {
    return (
        <>
            <Header />
            <div className="app-layout">
                <Sidebar />
                
              
                <main id="main" className="main">
                   <PageTitle page={document.title}/>
                    <Outlet /> {/* This will change dynamically */}
                </main>
            </div>
            <Footer />
        </>
    );
};

export default Layout;
